<template>
	<el-dialog title="编辑" width="1000px" :visible="editFormVisible" :close-on-click-modal="false" @close="editFormVisible_f">
		<div class="body datadata">
			<el-steps :active="step_step" align-center class="steps">
				<el-step title="基本信息"></el-step>
				<el-step title="植物学性状"></el-step>
				<el-step title="果形"></el-step>
				<el-step title="果皮"></el-step>
				<el-step title="果肉"></el-step>
				<el-step title="品质"></el-step>
			</el-steps>
			<el-form ref="editForm" :model="editForm" :rules="editFormRules" size="mini" label-position="top" label-width="80px">
				<div v-if="step_step==0">
					<el-row class="" :gutter="20">
						<el-col :span="8">
							<el-form-item label="片区/地块" prop="area_arr">
								<el-cascader v-model="editForm.area_arr" class="w100" :options="area_data" :props="{value:'id',label:'name'}" @change="area_f"></el-cascader>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="种质名称" prop="zhongzhimingcheng">
								<el-input v-model="editForm.zhongzhimingcheng" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="种植圃" prop="zhongzhipu">
								<el-input v-model="editForm.zhongzhipu" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="外文名" prop="waiwenming">
								<el-input v-model="editForm.waiwenming" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="亲本" prop="qinben">
								<el-input v-model="editForm.qinben" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="原产地" prop="yuanchandi">
								<el-input v-model="editForm.yuanchandi" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row class="" :gutter="20">
						<el-col :span="8">
							<el-form-item label="S基因型" prop="Sjiyinxing">
								<el-input v-model="editForm.Sjiyinxing" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="调查人" prop="diaocharen">
								<el-input v-model="editForm.diaocharen" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="来源" prop="laiyuan_value">
								<el-select v-model="editForm.laiyuan_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in LAIYUAN" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8" v-if="editForm.laiyuan_value=='-1'">
							<el-form-item label="其他来源" prop="laiyuan_text">
								<el-input v-model="editForm.laiyuan_text" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="调查时间" prop="diaochashijian">
								<el-date-picker v-model="editForm.diaochashijian" class="w100" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="调查地点" prop="diaochadidian">
								<el-input v-model="editForm.diaochadidian" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="用途" prop="yongtu_value">
								<el-select v-model="editForm.yongtu_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in PURPOSE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<div v-if="step_step==1">
					<el-row class="" :gutter="20">
						<el-col :span="8" class="yizu">
							<el-form-item label="树姿" prop="shuzi_value">
								<el-select v-model="editForm.shuzi_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in TREE_POSTURE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
							<el-card class="box-card">
								<el-form-item label="树势" prop="shushi_value">
									<el-select v-model="editForm.shushi_value" class="w100" placeholder="请选择">
										<el-option v-for="(item,index) in TREE_VIGOR" :key="index" :label="item" :value="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="树势图片" prop="shushi_image">
									<div class="el-upload el-upload--text shanchu"  v-for="(item,index) in editForm.shushi_image.show">
										<span class="el-upload-list__item-actions" @click="shanchu(index,'shushi_image')">
											<i class="el-icon-delete"></i>
										</span>
										<img :src="item" class="avatar">
									</div>
									<el-upload class="avatar-uploader" :action="http+'uploadImg'" :data="{name:'shushi_image'}" :show-file-list="false" :on-success="imageSuccess">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-card>
						</el-col>
						<el-col :span="8" class="yizu">
							<el-card class="box-card">
								<el-form-item label="一年生枝条颜色" prop="yinianshengzhitiaoyanse_value">
									<el-select v-model="editForm.yinianshengzhitiaoyanse_value" class="w100" placeholder="请选择">
										<el-option v-for="(item,index) in COLOUR_1" :key="index" :label="item" :value="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="一年生枝条颜色(其他)" prop="yinianshengzhitiaoyanse_text" v-if="editForm.yinianshengzhitiaoyanse_value=='-1'">
									<el-input v-model="editForm.yinianshengzhitiaoyanse_text" auto-complete="off"></el-input>
								</el-form-item>
								<el-form-item label="一年生枝条颜色图片" prop="yinianshengzhitiaoyanse_image">
									<div class="el-upload el-upload--text shanchu"  v-for="(item,index) in editForm.yinianshengzhitiaoyanse_image.show">
										<span class="el-upload-list__item-actions" @click="shanchu(index,'yinianshengzhitiaoyanse_image')">
											<i class="el-icon-delete"></i>
										</span>
										<img :src="item" class="avatar">
									</div>
									<el-upload class="avatar-uploader" :action="http+'uploadImg'" :data="{name:'yinianshengzhitiaoyanse_image'}" :show-file-list="false" :on-success="imageSuccess">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-card>
						</el-col>
						<el-col :span="8" class="yizu">
							<el-card class="box-card">
								<el-form-item label="新梢颜色" prop="xinshaoyanse_value">
									<el-select v-model="editForm.xinshaoyanse_value" class="w100" placeholder="请选择">
										<el-option v-for="(item,index) in COLOUR_2" :key="index" :label="item" :value="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="新梢颜色(其他)" prop="xinshaoyanse_text" v-if="editForm.xinshaoyanse_value=='-1'">
									<el-input v-model="editForm.xinshaoyanse_text" auto-complete="off"></el-input>
								</el-form-item>
								<el-form-item label="新梢颜色图片" prop="xinshaoyanse_image">
									<div class="el-upload el-upload--text shanchu"  v-for="item in editForm.xinshaoyanse_image.show">
										<span class="el-upload-list__item-actions" @click="shanchu(index,'xinshaoyanse_image')">
											<i class="el-icon-delete"></i>
										</span>
										<img :src="item" class="avatar">
									</div>
									<el-upload class="avatar-uploader" :action="http+'uploadImg'" :data="{name:'xinshaoyanse_image'}" :show-file-list="false" :on-success="imageSuccess">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-card>
						</el-col>
					</el-row>
					<el-row class="" :gutter="20">
						<el-col :span="8" class="yizu">
							<el-card class="box-card">
								<el-form-item label="春嫩叶色" prop="chunnenyese_value">
									<el-select v-model="editForm.chunnenyese_value" class="w100" placeholder="请选择">
										<el-option v-for="(item,index) in COLOUR_3" :key="index" :label="item" :value="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="春嫩叶色(其他)" prop="chunnenyese_text" v-if="editForm.chunnenyese_value=='-1'">
									<el-input v-model="editForm.chunnenyese_text" auto-complete="off"></el-input>
								</el-form-item>
								<el-form-item label="春嫩叶色图片" prop="chunnenyese_image">
									<div class="el-upload el-upload--text shanchu"  v-for="(item,index) in editForm.chunnenyese_image.show">
										<span class="el-upload-list__item-actions" @click="shanchu(index,'chunnenyese_image')">
											<i class="el-icon-delete"></i>
										</span>
										<img :src="item" class="avatar">
									</div>
									<el-upload class="avatar-uploader" :action="http+'uploadImg'" :data="{name:'chunnenyese_image'}" :show-file-list="false" :on-success="imageSuccess">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-card>
						</el-col>
						<el-col :span="8" class="yizu">
							<el-card class="box-card">
								<el-form-item label="叶柄颜色" prop="yebingyanse_value">
									<el-select v-model="editForm.yebingyanse_value" class="w100" placeholder="请选择">
										<el-option v-for="(item,index) in COLOUR_4" :key="index" :label="item" :value="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="叶柄颜色图片" prop="yebingyanse_image">
									<div class="el-upload el-upload--text shanchu"  v-for="(item,index) in editForm.yebingyanse_image.show">
										<span class="el-upload-list__item-actions" @click="shanchu(index,'yebingyanse_image')">
											<i class="el-icon-delete"></i>
										</span>
										<img :src="item" class="avatar">
									</div>
									<el-upload class="avatar-uploader" :action="http+'uploadImg'" :data="{name:'yebingyanse_image'}" :show-file-list="false" :on-success="imageSuccess">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-card>
						</el-col>
						<el-col :span="8" class="yizu">
							<el-card class="box-card">
								<el-form-item label="叶片" prop="yepianyanse_value">
									<el-select v-model="editForm.yepianyanse_value" class="w100" placeholder="请选择">
										<el-option v-for="(item,index) in COLOUR_5" :key="index" :label="item" :value="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="叶片(其他)" prop="yepianyanse_text" v-if="editForm.yepianyanse_value=='-1'">
									<el-input v-model="editForm.yepianyanse_text" auto-complete="off"></el-input>
								</el-form-item>
								<el-form-item label="叶片图片" prop="yepianyanse_image">
									<div class="el-upload el-upload--text shanchu"  v-for="(item,index) in editForm.yepianyanse_image.show">
										<span class="el-upload-list__item-actions" @click="shanchu(index,'yepianyanse_image')">
											<i class="el-icon-delete"></i>
										</span>
										<img :src="item" class="avatar">
									</div>
									<el-upload class="avatar-uploader" :action="http+'uploadImg'" :data="{name:'yepianyanse_image'}" :show-file-list="false" :on-success="imageSuccess">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-card>
						</el-col>
					</el-row>
					<el-row class="" :gutter="20">
						<el-col :span="8" class="yizu">
							<el-card class="box-card">
								<el-form-item label="蜜腺" prop="yexianxingzhuang_value">
									<el-select v-model="editForm.yexianxingzhuang_value" class="w100" placeholder="请选择">
										<el-option v-for="(item,index) in NECTARY" :key="index" :label="item" :value="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="蜜腺数量" prop="mixianshuliang">
									<el-input v-model="editForm.mixianshuliang" auto-complete="off"></el-input>
								</el-form-item>
							</el-card>
						</el-col>
						<el-col :span="8" class="yizu">
							<el-card class="box-card">
								<el-form-item label="花蕾颜色" prop="hualeiyanse_value">
									<el-select v-model="editForm.hualeiyanse_value" class="w100" placeholder="请选择">
										<el-option v-for="(item,index) in COLOUR_8" :key="index" :label="item" :value="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="花蕾颜色图片" prop="hualeiyanse_image">
									<div class="el-upload el-upload--text shanchu"  v-for="(item,index) in editForm.hualeiyanse_image.show">
										<span class="el-upload-list__item-actions" @click="shanchu(index,'hualeiyanse_image')">
											<i class="el-icon-delete"></i>
										</span>
										<img :src="item" class="avatar">
									</div>
									<el-upload class="avatar-uploader" :action="http+'uploadImg'" :data="{name:'hualeiyanse_image'}" :show-file-list="false" :on-success="imageSuccess">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-card>
						</el-col>
						<el-col :span="8" class="yizu">
							<el-card class="box-card">
								<el-form-item label="花径(cm)" prop="huajing">
									<el-input v-model="editForm.huajing" auto-complete="off"></el-input>
								</el-form-item>
								<el-form-item label="花径图片" prop="huajing_image">
									<div class="el-upload el-upload--text shanchu"  v-for="(item,index) in editForm.huajing_image.show">
										<span class="el-upload-list__item-actions" @click="shanchu(index,'huajing_image')">
											<i class="el-icon-delete"></i>
										</span>
										<img :src="item" class="avatar">
									</div>
									<el-upload class="avatar-uploader" :action="http+'uploadImg'" :data="{name:'huajing_image'}" :show-file-list="false" :on-success="imageSuccess">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-card>
						</el-col>
					</el-row>
					<el-row class="" :gutter="20">
						<el-col :span="8">
							<el-form-item label="叶片平展程度" prop="yepianpingzhanchengdu_value">
								<el-select v-model="editForm.yepianpingzhanchengdu_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in FLATTENING_DEGREE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="叶腺颜色" prop="yexianyanse_value">
								<el-select v-model="editForm.yexianyanse_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in COLOUR_7" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="8">
							<el-form-item label="叶腺数量(个)" prop="yexianshuliang">
								<el-input v-model="editForm.yexianshuliang" auto-complete="off"></el-input>
							</el-form-item>
						</el-col> -->
						<el-col :span="8">
							<el-form-item label="花朵数量(朵)" prop="huaduoshu">
								<el-input v-model="editForm.huaduoshu" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="萌芽期" prop="mengyaqi_value">
								<el-date-picker v-model="editForm.mengyaqi_value" class="w100" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="始花期" prop="shihuaqi_value">
								<el-date-picker v-model="editForm.shihuaqi_value" class="w100" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="末花期" prop="mohuaqi_value">
								<el-date-picker v-model="editForm.mohuaqi_value" class="w100" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="果实着色期" prop="guoshizhuoseqi_value">
								<el-date-picker v-model="editForm.guoshizhuoseqi_value" class="w100" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="果实成熟期" prop="guoshichengshuqi_value">
								<el-date-picker v-model="editForm.guoshichengshuqi_value" class="w100" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="果实生育期" prop="guoshishengyuqian_value">
								<el-input v-model="editForm.guoshishengyuqian_value" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="落叶期" prop="luoyeqi_value">
								<el-date-picker v-model="editForm.luoyeqi_value" class="w100" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<div v-if="step_step==2">
					<el-row class="" :gutter="20">
						<el-col :span="8" class="yizu">
							<el-card class="box-card">
								<el-form-item label="果形" prop="guoxing_value">
									<el-select v-model="editForm.guoxing_value" class="w100" placeholder="请选择">
										<el-option v-for="(item,index) in FRUIT_SHAPE" :key="index" :label="item" :value="index"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="果形(其他)" prop="guoxing_text" v-if="editForm.guoxing_value=='-1'">
									<el-input v-model="editForm.guoxing_text" auto-complete="off"></el-input>
								</el-form-item>
								<el-form-item label="果形图片" prop="guoxing_image">
									<div class="el-upload el-upload--text shanchu"  v-for="(item,index) in editForm.guoxing_image.show">
										<span class="el-upload-list__item-actions" @click="shanchu(index,'guoxing_image')">
											<i class="el-icon-delete"></i>
										</span>
										<img :src="item" class="avatar">
									</div>
									<el-upload class="avatar-uploader" :action="http+'uploadImg'" :data="{name:'guoxing_image'}" :show-file-list="false" :on-success="imageSuccess">
										<i class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-form-item>
							</el-card>
						</el-col>
						<el-col :span="8">
							<el-form-item label="平均果重(g)" prop="pingjunguozhong">
								<el-input v-model="editForm.pingjunguozhong" auto-complete="off"></el-input>
							</el-form-item>
							<el-form-item label="最大果重(g)" prop="zuidaguozhong">
								<el-input v-model="editForm.zuidaguozhong" auto-complete="off"></el-input>
							</el-form-item>
							<el-form-item label="梗洼(广)" prop="gengwa_value">
								<el-select v-model="editForm.gengwa_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in STEM_DEPRESSION" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="梗洼(深)" prop="gengwa2_value">
								<el-select v-model="editForm.gengwa2_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in STEM_DEPRESSION1" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="梗洼(陡)" prop="gengwa3_value">
								<el-select v-model="editForm.gengwa3_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in STEM_DEPRESSION2" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="整齐度" prop="zhengqidu_value">
								<el-select v-model="editForm.zhengqidu_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in UNIFORMITY" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="果顶" prop="guoding_value">
								<el-select v-model="editForm.guoding_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in FRUIT_APEX" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="缝合线" prop="fenghexian_value">
								<el-select v-model="editForm.fenghexian_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in SUTURE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="缝合线明显" prop="fenghexian2_value" v-if="editForm.fenghexian_value==1">
								<el-select v-model="editForm.fenghexian2_value" class="w100 " placeholder="请选择">
									<el-option v-for="(item,index) in SUTURE1" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<div v-if="step_step==3">
					<el-row class="" :gutter="20">
						<el-col :span="8">
							<el-form-item label="底色" prop="dise_value">
								<el-select v-model="editForm.dise_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in BACKGROUND_COLOR" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="盖色" prop="gaise_value">
								<el-select v-model="editForm.gaise_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in COLOUR_6" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="着色程度" prop="zhuosechengdu_value">
								<el-select v-model="editForm.zhuosechengdu_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in COLORING_DEGREE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="质地(厚)" prop="zhidi_value">
								<el-select v-model="editForm.zhidi_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in TEXTURE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="质地(韧)" prop="zhidi2_value">
								<el-select v-model="editForm.zhidi2_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in TEXTURE1" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="果形及外观色泽" prop="guoxingjiwaiguanseze_value">
								<el-select v-model="editForm.guoxingjiwaiguanseze_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in APPEARANCE_COLOR" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<div v-if="step_step==4">
					<el-row class="" :gutter="20">
						<el-col :span="8">
							<el-form-item label="色泽" prop="seze_value">
								<el-select v-model="editForm.seze_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in COLOR_AND_LUSTRE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="肉质" prop="rouzhi_value">
								<el-select v-model="editForm.rouzhi_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in MEAT_QUALITY" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="果肉厚度(cm)" prop="guorouhoudu">
								<el-input v-model="editForm.guorouhoudu" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="硬度" prop="yingdu">
								<el-input v-model="editForm.yingdu" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="汁液" prop="zhiye_value">
								<el-select v-model="editForm.zhiye_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in JUICE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="纤维(少)" prop="xianwei_value">
								<el-select v-model="editForm.xianwei_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in FIBRE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="纤维(细)" prop="xianwei2_value">
								<el-select v-model="editForm.xianwei2_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in FIBRE1" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="苦涩味" prop="kusewei_value">
								<el-select v-model="editForm.kusewei_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in BITTERNESS" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="香气" prop="xiangqi_value">
								<el-select v-model="editForm.xiangqi_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in AROMA" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="果核粘离" prop="guohenianli_value">
								<el-select v-model="editForm.guohenianli_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in STONE" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<div v-if="step_step==5">
					<el-row class="" :gutter="20">
						<el-col :span="8">
							<el-form-item label="风味" prop="fengwei_value">
								<el-select v-model="editForm.fengwei_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in FLAVOR" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="可溶性固形物含量(%)" prop="kerongxingguxingwuhanliang">
								<el-input v-model="editForm.kerongxingguxingwuhanliang" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="可溶性糖含量(%)" prop="kerongxingtanghanliang">
								<el-input v-model="editForm.kerongxingtanghanliang" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="总酸含量(%)" prop="kerongxingsuanhanliang">
								<el-input v-model="editForm.kerongxingsuanhanliang" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="Vc含量" prop="Vchanliang">
								<el-input v-model="editForm.Vchanliang" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="可滴定酸含量(%)" prop="kedidingsuanhanliang">
								<el-input v-model="editForm.kedidingsuanhanliang" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="微量元素" prop="weiliangyuansu">
								<el-input v-model="editForm.weiliangyuansu" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="可食率(%)" prop="keshilv">
								<el-input v-model="editForm.keshilv" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="鲜食品质" prop="xianshipinzhi_value">
								<el-select v-model="editForm.xianshipinzhi_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in QUALITY" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="耐贮性" prop="zhucunxing_value">
								<el-select v-model="editForm.zhucunxing_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in STORABILITY" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="裂果" prop="lieguo">
								<el-input v-model="editForm.lieguo" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="优点" prop="youdian">
								<el-input v-model="editForm.youdian" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="缺点" prop="quedian">
								<el-input v-model="editForm.quedian" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="病害" prop="binghai">
								<el-input v-model="editForm.binghai" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="鉴定意见" prop="jiandingyijian_value">
								<el-select v-model="editForm.jiandingyijian_value" class="w100" placeholder="请选择">
									<el-option v-for="(item,index) in OPINION" :key="index" :label="item" :value="index"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="备注" prop="beizhu">
								<el-input v-model="editForm.beizhu" auto-complete="off"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button size="mini" @click.native="editFormVisible_f">取消</el-button>
			<el-button type="primary" size="mini" v-if="step_is"  @click.native="editSubmit('editForm')">提交保存</el-button>
			<el-button type="primary" size="mini" v-if="!step_is" @click.native="editSubmit('editForm')">提交保存到下一步</el-button>
		</div>
	</el-dialog>
</template>
<script>
import global   from  '../global.vue'
export default {
	name: 'datadata',
	data() {
		
		return {
			http:global.http,
			editFormRules: {
				zhongzhimingcheng: [{
					required: true,
					message: '请输入种质名称',
					trigger: 'blur'
				}],
			},

			editForm: {
				area_arr:[],
				area: '',
				zhongzhipu: '',
				area_block: '',
				zhongzhimingcheng: '',
				zhongzhi_image:{
					show:[],
					save:[],
				},
				waiwenming: '',
				qinben: '',
				yuanchandi: '',
				qinben: '',
				Sjiyinxing: '',
				laiyuan_value: '',
				laiyuan_text: '',
				diaochashijian: '',
				diaocharen: '',
				diaochadidian: '',
				yongtu_value: '',

				shushi_value: '',
				shushi_image:{
					show:[],
					save:[],
				},
				shuzi_value: '',
				shuzi_image: {
					show:[],
					save:[],
				},
				yinianshengzhitiaoyanse_value: '',
				yinianshengzhitiaoyanse_text: '',
				yinianshengzhitiaoyanse_image: {
					show:[],
					save:[],
				},
				xinshaoyanse_value: '',
				xinshaoyanse_text: '',
				xinshaoyanse_image:{
					show:[],
					save:[],
				},
				chunnenyese_value: '',
				chunnenyese_text: '',
				chunnenyese_image:{
					show:[],
					save:[],
				},
				yebingyanse_value: '',
				yebingyanse_image: {
					show:[],
					save:[],
				},
				yepianyanse_value: '',
				yepianyanse_text: '',
				yepianyanse_image: {
					show:[],
					save:[],
				},
				yepianpingzhanchengdu_value: '',
				yexianxingzhuang_value: '',
				mixianshuliang: '',
				yexianxingzhuang_image: {
					show:[],
					save:[],
				},
				yexianyanse_value: '',
				yexianshuliang: '',
				mengyaqi_value: '',
				shihuaqi_value: '',
				mohuaqi_value: '',
				hualeiyanse_value: '',
				hualeiyanse_image:{
					show:[],
					save:[],
				},
				huaduoshu: '',
				huajing: '',
				huajing_image:{
					show:[],
					save:[],
				},
				guoshizhuoseqi_value: '',
				guoshichengshuqi_value: '',
				guoshishengyuqian_value: '',
				luoyeqi_value: '',

				pingjunguozhong: '',
				zuidaguozhong: '',
				guoxing_value: '',
				guoxing_text: '',
				guoxing_image: {
					show:[],
					save:[],
				},
				guoding_value: '',
				zhengqidu_value: '',
				fenghexian_value: '',
				fenghexian2_value: '',
				gengwa_value: '',
				gengwa2_value: '',
				gengwa3_value: '',

				dise_value: '',
				gaise_value: '',
				zhuosechengdu_value: '',
				zhidi_value: '',
				zhidi2_value: '',
				guoxingjiwaiguanseze_value: '',

				seze_value: '',
				rouzhi_value: '',
				guorouhoudu: '',
				yingdu: '',
				zhiye_value: '',
				xianwei_value: '',
				xianwei2_value: '',
				kusewei_value: '',
				xiangqi_value: '',
				guohenianli_value: '',

				fengwei_value: '',
				kerongxingguxingwuhanliang: '',
				kerongxingtanghanliang: '',
				kerongxingsuanhanliang: '',
				Vchanliang: '',
				kedidingsuanhanliang: '',
				weiliangyuansu: '',
				keshilv: '',
				xianshipinzhi_value: '',
				zhucunxing_value: '',
				lieguo: '',
				youdian: '',
				quedian: '',
				binghai: '',
				jiandingyijian_value: '',
				beizhu: '',
				info_id: '',
			},

			area_data: [],
			area_block_data: [],
			LAIYUAN: [],
			PURPOSE: [],
			TREE_VIGOR: [],
			TREE_POSTURE: [],
			COLOUR_1: [],
			COLOUR_2: [],
			COLOUR_3: [],
			COLOUR_4: [],
			COLOUR_5: [],
			COLOUR_6: [],
			COLOUR_7: [],
			COLOUR_8: [],
			FLATTENING_DEGREE: [],
			LEAF_GLAND_CHARACTERS: [],
			FRUIT_SHAPE: [],
			FRUIT_APEX: [],
			UNIFORMITY: [],
			SUTURE: [],
			STEM_DEPRESSION: [],
			STEM_DEPRESSION1: [],
			STEM_DEPRESSION2: [],
			BACKGROUND_COLOR: [],
			COLORING_DEGREE: [],
			TEXTURE: [],
			TEXTURE1: [],
			APPEARANCE_COLOR: [],
			COLOR_AND_LUSTRE: [],
			MEAT_QUALITY: [],
			JUICE: [],
			FIBRE: [],
			FIBRE1: [],
			BITTERNESS: [],
			AROMA: [],
			STONE: [],
			FLAVOR: [],
			QUALITY: [],
			STORABILITY: [],
			OPINION: [],
			NECTARY: [],
			SUTURE1: [],
			
			step_step:0,
		}
	},
	props: {
		step_is: {
			type: Boolean,
			default: false,
		},
		fenlei: {
			type: String,
			default: '',
		},
		step: {
			type: Number,
			default: 0,
		},
		editFormVisible:{
			type: Boolean,
			default: false
		},
		editForm_data: {
			type: Object,
			default: {}
		}
	},
	watch: {
		editForm_data(v){
			if (v.info_id) {
				this.editForm=v;
			}
		},
		step(v){
			console.log(v)
			this.step_step=v;
		},
	},
	mounted() {
		this.config();
	},
	methods: {
		config(){
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: 'LAIYUAN,PURPOSE,TREE_VIGOR,TREE_POSTURE,COLOUR_1,FLATTENING_DEGREE,LEAF_GLAND_CHARACTERS,FRUIT_SHAPE,FRUIT_APEX,UNIFORMITY,SUTURE,STEM_DEPRESSION,STEM_DEPRESSION1,STEM_DEPRESSION2,BACKGROUND_COLOR,COLOUR_2,COLOUR_3,COLOUR_4,COLOUR_5,COLOUR_6,COLOUR_7,COLOUR_8,COLORING_DEGREE,TEXTURE,TEXTURE1,APPEARANCE_COLOR,COLOR_AND_LUSTRE,MEAT_QUALITY,JUICE,FIBRE,FIBRE1,BITTERNESS,AROMA,STONE,FLAVOR,QUALITY,STORABILITY,OPINION,NECTARY,SUTURE1',
			}
			this_.$post(url, datas).then((res) => {
				this_.LAIYUAN = res.LAIYUAN;
				this_.PURPOSE = res.PURPOSE;
				this_.TREE_VIGOR = res.TREE_VIGOR;
				this_.TREE_POSTURE = res.TREE_POSTURE;
				this_.COLOUR_1 = res.COLOUR_1;
				this_.COLOUR_2 = res.COLOUR_2;
				this_.COLOUR_3 = res.COLOUR_3;
				this_.COLOUR_4 = res.COLOUR_4;
				this_.COLOUR_5 = res.COLOUR_5;
				this_.COLOUR_6 = res.COLOUR_6;
				this_.COLOUR_7 = res.COLOUR_7;
				this_.COLOUR_8 = res.COLOUR_8;
				this_.FLATTENING_DEGREE = res.FLATTENING_DEGREE;
				this_.LEAF_GLAND_CHARACTERS = res.LEAF_GLAND_CHARACTERS;
				this_.FRUIT_SHAPE = res.FRUIT_SHAPE;
				this_.FRUIT_APEX = res.FRUIT_APEX;
				this_.UNIFORMITY = res.UNIFORMITY;
				this_.SUTURE = res.SUTURE;
				this_.STEM_DEPRESSION = res.STEM_DEPRESSION;
				this_.STEM_DEPRESSION1 = res.STEM_DEPRESSION1;
				this_.STEM_DEPRESSION2 = res.STEM_DEPRESSION2;
				this_.BACKGROUND_COLOR = res.BACKGROUND_COLOR;
				this_.COLORING_DEGREE = res.COLORING_DEGREE;
				this_.TEXTURE = res.TEXTURE;
				this_.TEXTURE1 = res.TEXTURE1;
				this_.APPEARANCE_COLOR = res.APPEARANCE_COLOR;
				this_.COLOR_AND_LUSTRE = res.COLOR_AND_LUSTRE;
				this_.MEAT_QUALITY = res.MEAT_QUALITY;
				this_.JUICE = res.JUICE;
				this_.FIBRE = res.FIBRE;
				this_.FIBRE1 = res.FIBRE1;
				this_.BITTERNESS = res.BITTERNESS;
				this_.AROMA = res.AROMA;
				this_.STONE = res.STONE;
				this_.FLAVOR = res.FLAVOR;
				this_.QUALITY = res.QUALITY;
				this_.STORABILITY = res.STORABILITY;
				this_.OPINION = res.OPINION;
				this_.NECTARY = res.NECTARY;
				this_.SUTURE1 = res.SUTURE1;
			})
			var url = "areaOption";
			this_.$post(url, {}).then((res) => {
				this_.area_data = res;
			})
		},
		editFormVisible_f(){
			// this.step_step=0;
			this.editForm={
				area_arr:[],
				area: '',
				zhongzhipu: '',
				area_block: '',
				zhongzhimingcheng: '',
				zhongzhi_image:{
					show:[],
					save:[],
				},
				waiwenming: '',
				qinben: '',
				yuanchandi: '',
				qinben: '',
				Sjiyinxing: '',
				laiyuan_value: '',
				laiyuan_text: '',
				diaochashijian: '',
				diaocharen: '',
				diaochadidian: '',
				yongtu_value: '',

				shushi_value: '',
				shushi_image:{
					show:[],
					save:[],
				},
				shuzi_value: '',
				shuzi_image: {
					show:[],
					save:[],
				},
				yinianshengzhitiaoyanse_value: '',
				yinianshengzhitiaoyanse_text: '',
				yinianshengzhitiaoyanse_image: {
					show:[],
					save:[],
				},
				xinshaoyanse_value: '',
				xinshaoyanse_text: '',
				xinshaoyanse_image:{
					show:[],
					save:[],
				},
				chunnenyese_value: '',
				chunnenyese_text: '',
				chunnenyese_image:{
					show:[],
					save:[],
				},
				yebingyanse_value: '',
				yebingyanse_image: {
					show:[],
					save:[],
				},
				yepianyanse_value: '',
				yepianyanse_text: '',
				yepianyanse_image: {
					show:[],
					save:[],
				},
				yepianpingzhanchengdu_value: '',
				yexianxingzhuang_value: '',
				mixianshuliang: '',
				yexianxingzhuang_image: {
					show:[],
					save:[],
				},
				yexianyanse_value: '',
				yexianshuliang: '',
				mengyaqi_value: '',
				shihuaqi_value: '',
				mohuaqi_value: '',
				hualeiyanse_value: '',
				hualeiyanse_image:{
					show:[],
					save:[],
				},
				huaduoshu: '',
				huajing: '',
				huajing_image:{
					show:[],
					save:[],
				},
				guoshizhuoseqi_value: '',
				guoshichengshuqi_value: '',
				guoshishengyuqian_value: '',
				luoyeqi_value: '',

				pingjunguozhong: '',
				zuidaguozhong: '',
				guoxing_value: '',
				guoxing_text: '',
				guoxing_image: {
					show:[],
					save:[],
				},
				guoding_value: '',
				zhengqidu_value: '',
				fenghexian_value: '',
				fenghexian2_value: '',
				gengwa_value: '',
				gengwa2_value: '',
				gengwa3_value: '',

				dise_value: '',
				gaise_value: '',
				zhuosechengdu_value: '',
				zhidi_value: '',
				zhidi2_value: '',
				guoxingjiwaiguanseze_value: '',

				seze_value: '',
				rouzhi_value: '',
				guorouhoudu: '',
				yingdu: '',
				zhiye_value: '',
				xianwei_value: '',
				xianwei2_value: '',
				kusewei_value: '',
				xiangqi_value: '',
				guohenianli_value: '',

				fengwei_value: '',
				kerongxingguxingwuhanliang: '',
				kerongxingtanghanliang: '',
				kerongxingsuanhanliang: '',
				Vchanliang: '',
				kedidingsuanhanliang: '',
				weiliangyuansu: '',
				keshilv: '',
				xianshipinzhi_value: '',
				zhucunxing_value: '',
				lieguo: '',
				youdian: '',
				quedian: '',
				binghai: '',
				jiandingyijian_value: '',
				beizhu: '',
				info_id: '',
			};
			this.$emit("editFormVisible_f",false);
		},
		area_f(e) {
			var this_ = this;
			this_.editForm.area=e[0];
			this_.editForm.area_block=e[1];
		},
		// 图片上传
		imageSuccess(res, file) {
			if (res.status == 200) {
				this.editForm[res.data.name].save.push(res.data.savename);
				this.editForm[res.data.name].show.push(res.data.showname);
				this.$refs.editForm.clearValidate(res.data.name);
			} else {
				his_.$message.success(res.message);
			}
		},
		shanchu(index,name){
			var this_ = this;
			var editForm=this_.editForm[name];
			this_.$confirm('确认删除吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				this_.removeByIndex(editForm.save,index);
				this_.removeByIndex(editForm.show,index);
			}).catch(() => {
			});
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs[editForm].validate((valid) => {
				if (valid) {
					var url = "infoAction";
					if (this_.step_step==0) {
						var datas = {
							step:this_.step_step,
							area: this_.editForm.area,
							area_block: this_.editForm.area_block,
							zhongzhimingcheng: this_.editForm.zhongzhimingcheng,
							zhongzhi_image: this_.editForm.zhongzhi_image.save?JSON.stringify(this_.editForm.zhongzhi_image.save):'',
							zhongzhipu: this_.editForm.zhongzhipu,
							waiwenming: this_.editForm.waiwenming,
							qinben: this_.editForm.qinben,
							yuanchandi: this_.editForm.yuanchandi,
							Sjiyinxing: this_.editForm.Sjiyinxing,
							laiyuan_value: this_.editForm.laiyuan_value,
							laiyuan_text: this_.editForm.laiyuan_text,
							diaochashijian: this_.editForm.diaochashijian,
							diaocharen: this_.editForm.diaocharen,
							diaochadidian: this_.editForm.diaochadidian,
							yongtu_value: this_.editForm.yongtu_value,
						}
					}else if(this_.step_step==1){
						var datas = {
							step:this_.step_step,
							shushi_value: this_.editForm.shushi_value,
							shushi_image: this_.editForm.shushi_image.save?JSON.stringify(this_.editForm.shushi_image.save):'',
							shuzi_value: this_.editForm.shuzi_value,
							shuzi_image: this_.editForm.shuzi_image.save?JSON.stringify(this_.editForm.shuzi_image.save):'',
							yinianshengzhitiaoyanse_value: this_.editForm.yinianshengzhitiaoyanse_value,
							yinianshengzhitiaoyanse_text: this_.editForm.yinianshengzhitiaoyanse_text,
							yinianshengzhitiaoyanse_image: this_.editForm.yinianshengzhitiaoyanse_image.save?JSON.stringify(this_.editForm.yinianshengzhitiaoyanse_image.save):'',
							xinshaoyanse_value: this_.editForm.xinshaoyanse_value,
							xinshaoyanse_text: this_.editForm.xinshaoyanse_text,
							xinshaoyanse_image: this_.editForm.xinshaoyanse_image.save?JSON.stringify(this_.editForm.xinshaoyanse_image.save):'',
							chunnenyese_value: this_.editForm.chunnenyese_value,
							chunnenyese_text: this_.editForm.chunnenyese_text,
							chunnenyese_image: this_.editForm.chunnenyese_image.save?JSON.stringify(this_.editForm.chunnenyese_image.save):'',
							yebingyanse_value: this_.editForm.yebingyanse_value,
							yebingyanse_image: this_.editForm.yebingyanse_image.save?JSON.stringify(this_.editForm.yebingyanse_image.save):'',
							yepianyanse_value: this_.editForm.yepianyanse_value,
							yepianyanse_text: this_.editForm.yepianyanse_text,
							yepianyanse_image: this_.editForm.yepianyanse_image.save?JSON.stringify(this_.editForm.yepianyanse_image.save):'',
							yepianpingzhanchengdu_value: this_.editForm.yepianpingzhanchengdu_value,
							yexianxingzhuang_value: this_.editForm.yexianxingzhuang_value,
							mixianshuliang: this_.editForm.mixianshuliang,
							yexianxingzhuang_image: this_.editForm.yexianxingzhuang_image.save?JSON.stringify(this_.editForm.yexianxingzhuang_image.save):'',
							yexianyanse_value: this_.editForm.yexianyanse_value,
							yexianshuliang: this_.editForm.yexianshuliang,
							mengyaqi_value: this_.editForm.mengyaqi_value,
							shihuaqi_value: this_.editForm.shihuaqi_value,
							mohuaqi_value: this_.editForm.mohuaqi_value,
							hualeiyanse_value: this_.editForm.hualeiyanse_value,
							hualeiyanse_image: this_.editForm.hualeiyanse_image.save?JSON.stringify(this_.editForm.hualeiyanse_image.save):'',
							
							huaduoshu: this_.editForm.huaduoshu,
							huajing: this_.editForm.huajing,
							huajing_image: this_.editForm.huajing_image.save?JSON.stringify(this_.editForm.huajing_image.save):'',
							guoshizhuoseqi_value: this_.editForm.guoshizhuoseqi_value,
							guoshichengshuqi_value: this_.editForm.guoshichengshuqi_value,
							guoshishengyuqian_value: this_.editForm.guoshishengyuqian_value,
							luoyeqi_value: this_.editForm.luoyeqi_value,
						}
					}else if(this_.step_step==2){
						var datas = {
							step:this_.step_step,
							pingjunguozhong: this_.editForm.pingjunguozhong,
							zuidaguozhong: this_.editForm.zuidaguozhong,
							guoxing_value: this_.editForm.guoxing_value,
							guoxing_text: this_.editForm.guoxing_text,
							guoxing_image: this_.editForm.guoxing_image.save?JSON.stringify(this_.editForm.guoxing_image.save):'',
							guoding_value: this_.editForm.guoding_value,
							zhengqidu_value: this_.editForm.zhengqidu_value,
							fenghexian_value: this_.editForm.fenghexian_value,
							fenghexian2_value: this_.editForm.fenghexian2_value,
							gengwa_value: this_.editForm.gengwa_value,
							gengwa2_value: this_.editForm.gengwa2_value,
							gengwa3_value: this_.editForm.gengwa3_value,
						}
					}else if(this_.step_step==3){
						var datas = {
							step:this_.step_step,
							dise_value: this_.editForm.dise_value,
							gaise_value: this_.editForm.gaise_value,
							zhuosechengdu_value: this_.editForm.zhuosechengdu_value,
							zhidi_value: this_.editForm.zhidi_value,
							zhidi2_value: this_.editForm.zhidi2_value,
							guoxingjiwaiguanseze_value: this_.editForm.guoxingjiwaiguanseze_value,
						}
					}else if(this_.step_step==4){
						var datas = {
							step:this_.step_step,
							seze_value: this_.editForm.seze_value,
							rouzhi_value: this_.editForm.rouzhi_value,
							guorouhoudu: this_.editForm.guorouhoudu,
							yingdu: this_.editForm.yingdu,
							zhiye_value: this_.editForm.zhiye_value,
							xianwei_value: this_.editForm.xianwei_value,
							xianwei2_value: this_.editForm.xianwei2_value,
							kusewei_value: this_.editForm.kusewei_value,
							xiangqi_value: this_.editForm.xiangqi_value,
							guohenianli_value: this_.editForm.guohenianli_value,
						}
					}else if(this_.step_step==5){
						var datas = {
							step:this_.step_step,
							fengwei_value: this_.editForm.fengwei_value,
							kerongxingguxingwuhanliang: this_.editForm.kerongxingguxingwuhanliang,
							kerongxingtanghanliang: this_.editForm.kerongxingtanghanliang,
							kerongxingsuanhanliang: this_.editForm.kerongxingsuanhanliang,
							Vchanliang: this_.editForm.Vchanliang,
							kedidingsuanhanliang: this_.editForm.kedidingsuanhanliang,
							weiliangyuansu: this_.editForm.weiliangyuansu,
							keshilv: this_.editForm.keshilv,
							xianshipinzhi_value: this_.editForm.xianshipinzhi_value,
							zhucunxing_value: this_.editForm.zhucunxing_value,
							lieguo: this_.editForm.lieguo,
							youdian: this_.editForm.youdian,
							quedian: this_.editForm.quedian,
							binghai: this_.editForm.binghai,
							jiandingyijian_value: this_.editForm.jiandingyijian_value,
							beizhu: this_.editForm.beizhu,
						}
					}
					var tishi = '添加成功';
					datas['fenlei']=this_.fenlei;
					if (this_.editForm.info_id) {
						datas['id'] = this_.editForm.info_id;
						url = "infoAction";
						tishi = '修改成功';
						datas['fenlei']=this_.editForm.fenlei;
					}
					this_.$post(url, datas).then((res) => {
						this_.editForm.info_id=res;
						this_.$message.success(tishi);
						if (this_.step_is) {
							this_.editFormVisible_f();
						}else{
							if (this_.step_step<5) {
								this_.step_step=this_.step_step+1;
							}else{
								this_.editFormVisible_f();
								this_.step_step=0;
							}
						}
					});
				} else {
					return false;
				}
			})
		},
	}
}
</script>
<style scoped>
.body {
	padding: 20px;
	background-color: #fff;
}
.body .steps {
	margin-bottom: 20px;
}
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.page-pagination {
	padding: 20px 10px;
}
.filter-inline-panel {
	margin-bottom: 10px;
}
.anjian{
	text-align: center;
}
</style>
<style type="text/css">
.datadata .avatar-uploader{
	display: inline-block;
	vertical-align: top;
	/* margin-right: 10px; */
	/* margin-bottom: 10px; */
}

.datadata .el-upload {
	margin-right: 10px;
	margin-bottom: 10px;
	position: relative;
}
.datadata .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}
.datadata .avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.datadata .avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 80px;
	height: 80px;
	line-height: 80px;
	text-align: center;
}
.datadata .avatar {
	width: 80px;
	height: 80px;
	display: block;
}
.datadata .el-form-item--mini .el-form-item__label{
	line-height: 20px;
	padding-bottom: 5px;
}
.datadata .el-upload-list__item-actions{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%; 
	text-align: center;
	line-height: 80px;
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.5);
	display: none;
}
.datadata .shanchu:hover .el-upload-list__item-actions{
	display: block;
}
.datadata .el-upload-list__item-actions i{
	font-size: 20px;
	color: #fff;
}
.datadata .el-form-item--mini.el-form-item{
	/* margin-bottom: 10px; */
}
.datadata .el-date-editor.el-input.w100{
	width: 100%;
}
.el-card{
	margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/datadata.vue